import { Link } from "react-router-dom";
import { STATUS_LABEL } from "@/lib/api";

// Chips der Aufträge, mit denen eine Kundendatei verknüpft ist (offene Aufträge blau, abgeschlossene grau)
export function FileOrderChips({ orders, currentOrderId = null, testPrefix = "file", showVersion = false, emptyText = "keinem Auftrag zugeordnet" }) {
  if (!orders?.length) return <span className="text-xs text-slate-400 italic">{emptyText}</span>;
  return (
    <div className="flex flex-wrap gap-1.5">
      {orders.map((o) => (
        <Link
          key={o.order_id}
          to={`/auftraege/${o.order_id}`}
          title={`${o.titel ? `${o.titel} · ` : ""}${STATUS_LABEL[o.status] || o.status || ""}${o.outdated ? " · verwendet eine ältere Version" : ""}`}
          className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-mono transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
            o.order_id === currentOrderId ? "bg-emerald-50 text-emerald-700 border-emerald-200"
              : o.outdated ? "bg-amber-50 text-amber-800 border-amber-300 hover:bg-amber-100"
              : o.abgeschlossen ? "bg-slate-50 text-slate-500 border-slate-200 hover:bg-slate-100" : "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100"}`}
          data-testid={`${testPrefix}-order-chip-${o.auftragsnummer}`}
        >
          {o.auftragsnummer}
          {(showVersion || o.version > 1) && <span className="opacity-70">v{o.version}</span>}
          {o.outdated && <span className="sr-only">(ältere Version)</span>}
        </Link>
      ))}
    </div>
  );
}
